import React from "react";
import img3 from "../../Images/Rooms/heroBedroom.jpg";
import "./Babout.css";
function Babout() {
  return (
    <div className="Babout">
      {/* <hr style={{ borderColor: "#faf7f7" }}></hr> */}
      <div className="b-upper">
        <figure className="b-fig1">
          <img src={img3} alt="img1" className="b-about-img1" />{" "}
        </figure>
        <div className="upper-details">
          <p className="b-upper-details-title">Stay Longer, Save more</p>
          <p className="b-upper-details-about">
            Embrace the coziness of our single bedrooms, where modern comforts
            blend seamlessly with natural beauty
          </p>
          <button className="b-about-btn"> Book Now</button>
        </div>
      </div>
    </div>
  );
}

export default Babout;
